import React, { useContext } from 'react';
import { Button } from 'components';
import { AvatarUploadForm } from 'forms';
import { routeConstants } from 'routes';
import { AdminOnboardingContext } from './AccountSetupLayout';
import { AccountSetupFooter, AccountSetupHeader } from './components';

const AccountSetupAvatar = () => {
  const isTipIneligibleAdmin = useContext(AdminOnboardingContext);
  // Routing
  const nextStep = isTipIneligibleAdmin ? routeConstants.private.accountSetup.complete : routeConstants.private.accountSetup.paymentMethod;

  return (
    <>
      <AccountSetupHeader data-cy="account-setup-header" title="Add a Profile photo" message="Add a photo so your employer can identify you easier. It’s optional if you’d prefer to leave it blank." />

      <AvatarUploadForm />

      <AccountSetupFooter>
        <Button appearance="primary" size="large" label="Next" to={nextStep} data-cy="account-setup-profile-photo-button" />
      </AccountSetupFooter>
    </>
  );
};

export default AccountSetupAvatar;
